(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initVideoEndOverlay() {
      var isMobile = window.innerWidth <= 1024 && window.innerHeight > window.innerWidth;
      var video = document.getElementById(isMobile ? 'hero-video-mobile' : 'hero-video-desktop');
      var overlay = document.getElementById('hero-video-end-overlay');

      if (!video || !overlay) return;

      video.addEventListener('ended', function() {
        overlay.classList.add('is-visible');
      }, { once: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoEndOverlay);
    } else {
      initVideoEndOverlay();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
